import { string } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import env from '../../../utils/env';
import Detail from '../Detail/Detail';

const ReferAFriend = (props) => {
  const { title, desc, cta } = props;

  return (
    <Detail icon="fa-money-bill-wave" title={title} description={desc}>
      <>
        <br />
        <Button
          width="100%"
          onClick={() => {
            window.location = `${env.envURL}/invite/`;
          }}
        >
          {cta}
        </Button>
      </>
    </Detail>
  );
};

ReferAFriend.propTypes = {
  title: string.isRequired,
  desc: string.isRequired,
  cta: string.isRequired,
};

export default ReferAFriend;
